import { useEffect, useRef } from 'react';
import './index.less';
import * as monaco from 'monaco-editor';
import { Editor } from '@monaco-editor/react';
import classNames from 'classnames';

interface Iprops {
    code: string;
    updateCode: (code: string) => void;
    onSave: (value) => void
    wrapClassName?: string;
    language?: string;
    id?: string
}

export function CodeEditor(props: Iprops) {
    const { code, updateCode, onSave, wrapClassName } = props;

    const editorRef = useRef(null);

    const handleEditorDidMount = (editor: monaco.editor.IStandaloneCodeEditor, monaco: typeof import('monaco-editor')) => {
        editorRef.current = editor;
        editor.focus();


    }

    useEffect(() => {
        if (editorRef.current) {
            const editor = editorRef.current;
            // 监听Ctrl+S
            const handleSaveCommand = (event: KeyboardEvent) => {
                // event.preventDefault(); // 阻止默认行为（例如浏览器保存）
                // 获取当前编辑器的值
                const currentCode = editor.getValue();
                onSave(currentCode); // 调用 onSave
            };

            editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, handleSaveCommand);

            // 清理副作用
            return () => {
                if (editor.removeCommand) {
                    editor.removeCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, handleSaveCommand);
                }
            };
        }
    }, [code])

    const handleEditorChange = (value: string | undefined, event: monaco.editor.IModelContentChangedEvent) => {
        updateCode(value || '');
    }


    return (
        <div id={props.id ? props.id : "default-code-editor-id"} className={classNames({ 'code-editor': true }, wrapClassName)}>
            <Editor
                defaultLanguage={props.language ? props.language : "javascript"}
                language={props.language ? props.language : "javascript"}
                value={code}
                onMount={handleEditorDidMount}
                onChange={handleEditorChange}
                theme={'light'}
                options={{
                    automaticLayout: true, // 自动处理布局
                }}
            />
        </div>
    )
}